export const STOCK_TRANSFER_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "stock-transfers",
        text: "Stock transfer"
    },
]